import angular from 'angular';

angular.module('cloudX').directive('cxLoading', [
  '$compile',
  function($compile) {
    var loadingSpinner =
      '<div class="spinner">' +
      '<div class="bounce1"></div>' +
      '<div class="bounce2"></div>' +
      '<div class="bounce3"></div>' +
      '</div>';

    return {
      restrict: 'A',
      terminal: true,

      link: function(scope, element, attrs) {
        var originalContent = element.html();
        element.html(loadingSpinner);

        scope.$watch(attrs.cxLoading, function(val) {
          if (val === false || (val && val !== true)) {
            element.html(originalContent);
            $compile(element.contents())(scope);
          } else {
            element.html(loadingSpinner);
          }
        });
      },
    };
  },
]);
